import React, { useState } from 'react';
import { Button, Modal } from '@mantine/core';
import { Plus } from 'tabler-icons-react';
import { ResourceForm } from './ResourceForm';
import { useTranslation } from 'react-i18next';

export function ResourceCreateDialog() {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Button
        color="green"
        size="md"
        variant="light"
        leftIcon={<Plus />}
        onClick={() => setOpened(true)}
      >
        {t('ResourceCreateDialog.Title')}
      </Button>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        size="lg"
        title={t('ResourceCreateDialog.Title')}
      >
        <ResourceForm create={true} onFinish={() => setOpened(false)} />
      </Modal>
    </>
  );
}
